import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WhatsappModalContent from '../../components/WhatsappModalContent';

import { optInToWhatsapp } from '../../actions/orderActions';

import { isFeatureActive } from '../../selectors/configSelectors';
import { getOrderStatus } from '../../selectors/orderStatusSelectors';
import { WHATSAPP_BANNER_2018 } from '../../flags/features';

export class InfoBannerModalWhatsappContainer extends Component {
  state = {
    switchOn: false,
  };

  getHeader() {
    return 'Enable WhatsApp notifications';
  }

  onSave = () => {
    if (this.state.switchOn) {
      this.props.onOptInToWhatsapp();
    }
  };

  onSwitchChange = (event) => {
    this.setState({
      switchOn: event,
    });
  };

  render() {
    return (
      <WhatsappModalContent onSwitchChange={this.onSwitchChange} optedIn={this.state.switchOn} />
    );
  }
}

InfoBannerModalWhatsappContainer.propTypes = {
  /** Function called when modal, and type whatsapp and user opts in */
  onOptInToWhatsapp: PropTypes.func,
};

InfoBannerModalWhatsappContainer.defaultProps = {
  onOptInToWhatsapp: () => {},
};

export const mapStateToProps = (state) => {
  const infoBanner = getOrderStatus(state).infoBanner;
  const whatsappOptedIn = infoBanner && infoBanner.whatsappOptedIn;
  const whatsappBannerFeatureOn = isFeatureActive(state, WHATSAPP_BANNER_2018);

  return {
    whatsappOptedIn,
    whatsappBannerFeatureOn,
  };
};

const mapActionsToProps = (dispatch) => ({
  onOptInToWhatsapp: () => dispatch(optInToWhatsapp()),
});

export default connect(
  mapStateToProps,
  mapActionsToProps,
  null,
  { forwardRef: true },
)(InfoBannerModalWhatsappContainer);
